import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Cart = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Cart' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M5,5 L22,5 L20,14 L7,14 L4,2 L0,2 M7,14 L8,18 L21,18 M19,23 C18.4475,23 18,22.5525 18,22 C18,21.4475 18.4475,21 19,21 C19.5525,21 20,21.4475 20,22 C20,22.5525 19.5525,23 19,23 Z M9,23 C8.4475,23 8,22.5525 8,22 C8,21.4475 8.4475,21 9,21 C9.5525,21 10,21.4475 10,22 C10,22.5525 9.5525,23 9,23 Z' />
  </StyledIcon>
);
